import React from "react";
import { Modal, Form, Input, message, Button } from "antd";
import { useAsync } from "../../../../utils/use-async";
import { client } from "../../../../utils/api-client";
import { Spinner } from "../../../lib";

const CreateDepartment = ({
  modal,
  fetchDepartments,
  handleCancel,
  setModal,
}) => {
  const { isLoading, run, isError, error } = useAsync();

  const addDepartment = (values) => {
    run(
      client("department/create", { body: values }).then((res) => {
        message.success(res.message);
        setModal(false);
        fetchDepartments();
      })
    );
  };

  return (
    <Modal title="Create Department" visible={modal} onCancel={handleCancel}>
      <Form
        size="middle"
        layout="horizontal"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        onFinish={addDepartment}
      >
        <Form.Item
          label="Department name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please input department name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item {...{ wrapperCol: { offset: 8, span: 16 } }}>
          <Button type="primary" htmlType="submit">
            Submit{" "}
            {isLoading && (
              <span style={{ marginLeft: "5px", verticalAlign: "middle" }}>
                <Spinner />
              </span>
            )}
          </Button>
        </Form.Item>
        {isError && <p style={{ color: "red" }}>{error.message}</p>}
      </Form>
    </Modal>
  );
};

export default CreateDepartment;
